"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditViewSubform = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const image_button_1 = require("../../components/button/image.button");
const icon_1 = require("../../components/icon");
const icons_1 = require("../../components/icon/icons");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const topological_editor_collection_edit_ctrl_1 = require("../../page/topological.editor.page/topological.editor.collection.edit.ctrl");
const classnames_1 = require("../../util/classnames");
const collection_view_field_1 = require("./collection.view.field");
const collection_view_style_1 = require("./collection.view.style");
const subform_duplicate_tool_1 = require("./subform.tool/subform.duplicate.tool");
const subform_remove_tool_1 = require("./subform.tool/subform.remove.tool");
class CollectionEditViewSubform {
    static view(ctrl, collection) {
        let showTrueSizeRedDotFieldId = null;
        if (collection instanceof core_shared_1.CollectionModel) {
            const rootTrueSizeFields = collection.schema.fields.filter((f) => !core_shared_1.FormModelFieldSubForm.isSubForm(f) && f.type === core_api_1.IkeFieldType.TRUE_SIZE);
            const anyRootTrueSizeHasValue = rootTrueSizeFields.some((f) => collection.getField(f.id).hasValue());
            showTrueSizeRedDotFieldId =
                !anyRootTrueSizeHasValue && rootTrueSizeFields.length > 0 ? rootTrueSizeFields[0].id : null;
        }
        const realFields = [];
        const subForms = [];
        for (const field of collection.schema.fields) {
            if (core_shared_1.FormModelFieldSubForm.isSubForm(field)) {
                subForms.push(CollectionEditViewSubform.viewSubform(ctrl, collection, field));
            }
            else {
                realFields.push(collection_view_field_1.CollectionEditViewField.view(ctrl, collection, field, showTrueSizeRedDotFieldId === field.id));
            }
        }
        const className = `${collection_view_style_1.CSS.form.container} ${collection_view_style_1.CSS.form.isRoot}`;
        const id = `i-${collection.instanceId}`;
        const style = {
            display: topological_editor_collection_edit_ctrl_1.TopologicalEditorCollectionEditCtrl.is(ctrl) && ctrl.isCarouselShown === true ? 'none' : 'block',
        };
        return (0, mithril_1.m)('div', { className, id, style }, realFields.concat(subForms));
    }
    static viewSubform(ctrl, collection, schema) {
        const id = `i-${collection.instanceId}-${schema.id}`;
        const field = collection.getField(schema.id);
        const instances = field.value || [];
        const isEmpty = instances.length === 0 ? collection_view_style_1.CSS.isEmpty : '';
        let showFooter = false;
        const children = [];
        for (const instance of instances) {
            children.push(CollectionEditViewSubform.viewInstance(ctrl, instance));
            showFooter = showFooter || ctrl.isExpanded(instance.instanceId);
        }
        const title = schema.displayName;
        const userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) ||
            services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        const userCanEditField = userIsAdmin || !field.schema.adminOnly;
        return (0, mithril_1.m)('div', {
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.form.container, isEmpty),
            id,
        }, [
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.header }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.title }, [
                    (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.titleName, title }, title),
                    instances.length > 0 ? (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.titleCount }, String(instances.length)) : null,
                ]),
                ctrl.isEditing && userCanEditField ? CollectionEditViewSubform.viewEditTools(ctrl, collection, schema) : null,
            ]),
            ...children,
            ctrl.isEditing && showFooter && userCanEditField
                ? CollectionEditViewSubform.viewFooter(ctrl, collection, schema)
                : null,
        ]);
    }
    static viewInstance(ctrl, collection) {
        const id = `i-${collection.instanceId}`;
        const instanceTitle = collection.title;
        const formTitle = collection.formTitle;
        let title = formTitle;
        if (instanceTitle != null && instanceTitle !== formTitle) {
            title = `${formTitle} — ${instanceTitle}`;
        }
        const isExpanded = ctrl.isExpanded(collection.instanceId);
        const spanColor = ctrl.useColorCoding ? core_shared_1.FormModelFieldSubForm.getSpanColor(collection) : 'none';
        return (0, mithril_1.m)('div', {
            id,
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.instance.container, {
                [collection_view_style_1.CSS.instance.isOpen]: isExpanded,
            }),
        }, [
            (0, mithril_1.m)('div', {
                title,
                onclick: (e) => ctrl.toggleExpanded(e, collection.instanceId),
                className: collection_view_style_1.CSS.instance.header,
                style: { 'border-left': `6px solid ${spanColor}` },
            }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.instance.text }, title),
                CollectionEditViewSubform.viewInstanceEditTools(ctrl, collection),
            ]),
            isExpanded ? CollectionEditViewSubform.view(ctrl, collection) : null,
        ]);
    }
    static viewEditTools(ctrl, collection, schema) {
        const field = collection.getField(schema.id);
        const title = schema.displayName;
        const tools = [];
        if (services_1.Services.SubFormLink.isSubFormCompatible(schema)) {
            tools.push(image_button_1.ImageButton.view(icons_1.MaterialIcon.SPAN_LINK, {
                title: i18n_1.T.SPAN_LINK_TITLE,
                onclick: () => ctrl.beginSpanLink(collection),
            }));
        }
        tools.push(image_button_1.ImageButton.view(icons_1.MaterialIcon.ADD, {
            title: i18n_1.T.COLLECTION_EDIT_CREATE_SUBFORM,
            titleAttrs: { title },
            onclick: () => field.Mutator.create(),
        }));
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.tools }, tools);
    }
    static viewFooter(ctrl, collection, schema) {
        const field = collection.getField(schema.id);
        const buttons = [
            (0, mithril_1.m)('button', { className: collection_view_style_1.CSS.form.footerButton + ' mdl-button', onclick: () => field.Mutator.create() }, [
                icon_1.Icon.view(icons_1.MaterialIcon.ADD),
                (0, mithril_1.m)('span', `Add new ${schema.displayName}`),
            ]),
        ];
        if (services_1.Services.SubFormLink.isSubFormCompatible(schema)) {
            buttons.push((0, mithril_1.m)('button', { className: collection_view_style_1.CSS.form.footerButton + ' mdl-button', onclick: () => ctrl.beginSpanLink(collection) }, [icon_1.Icon.view(icons_1.MaterialIcon.SPAN_LINK), (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_TITLE))]));
        }
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.footer }, buttons);
    }
    static viewInstanceEditTools(ctrl, collection) {
        const userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) ||
            services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        const userCanEditField = userIsAdmin || !collection.schema.adminOnly;
        if (!(ctrl.isEditing && userCanEditField)) {
            return null;
        }
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.instance.tools }, [
            subform_duplicate_tool_1.SubformDuplicateTool.view(collection),
            subform_remove_tool_1.SubformRemoveTool.view(ctrl, collection),
        ]);
    }
}
exports.CollectionEditViewSubform = CollectionEditViewSubform;
//# sourceMappingURL=collection.view.subform.js.map